//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {  getHomePageCommodity } from './../../service/index'
import { go } from './../../util/router'
export default {
  name: 'hello',
  data () {
    return {
      CommodityList: [],
      pageIndex: 0,
      pageSize: 20,
      pageCount: 0,
      isLock: false,
      noMore: false,
      otype: ''// 现货抢购|现货选配|其他
    }
  },
  components: {
  },
  created () {
    this.getHomePageCommodity()
  },
  mounted () {
    this.pagescroll()
  },
  methods: {
    getHomePageCommodity () {
      let vm = this
      let pData = {
        pageNum: vm.pageIndex,
        pageSize: vm.pageSize
      }
      vm.isLock = true
      getHomePageCommodity(pData, (result) => {
        vm.isLock = false
        console.log(JSON.parse(result.data))
        if (result.code === '1') {
          let ls = JSON.parse(result.data)
          for (let item of ls) {
            vm.CommodityList.push(item)
          }
          if(ls.length<vm.pageSize){
            vm.noMore = true
          }
        }
      })
    },
    doDetail (oid) {
      this.$router.push({ path: '/Detail/' + oid, query: { otype: 'XHXP' }}) // 现货选配
      // go('/Detail/' + oid, this.$router)
    },
    pagescroll () {
      let self = this
      window.onscroll = function () {
        let body = document.body
        let scrollTop = body.scrollTop === 0 ? document.documentElement.scrollTop : body.scrollTop
        let dHeight = body.scrollHeight
        let height = document.documentElement.clientHeight
        // console.log(scrollTop + '|' + dHeight + '｜' + height)
        // console.log((scrollTop + height), dHeight)
        if ((scrollTop + height) >= dHeight-100) {
          // console.log(self.pageCount, self.pageIndex, self.pageSize)
          if (!self.isLock && !self.noMore) {
            self.isLock = true
            self.pageIndex += 1
            self.getHomePageCommodity()
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/home/bestlist.vue